import React from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Select,
  FormErrorMessage,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from "@chakra-ui/react";

const CustomSingleInput = ({
  label,
  subLabel,
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  required = false,
  disabled = false,
  type = "text",
  area = false,
  select = false,
  options = [],
  leftElement,
  rightElement,
  mb = 0,
  ...props
}) => {
  // Field styles
  const fieldStyles = {
    bg: "white",
    borderColor: "gray.300",
    _hover: {
      borderColor: "gray.400",
    },
    _focus: {
      borderColor: "blue.500",
      boxShadow: "0 0 0 1px #3182ce",
    },
    _invalid: {
      borderColor: "red.500",
      boxShadow: "0 0 0 1px #e53e3e",
    },
    _disabled: {
      bg: "gray.100",
      borderColor: "gray.200",
      color: "black",
      cursor: "not-allowed",
      opacity: 1,
      _hover: {
        borderColor: "gray.200",
      },
    },
    size: "md",
  };

  return (
    <Box mb={mb} {...props}>
      <FormControl isInvalid={!!error} isRequired={required}>
        {label && (
          <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
            {label}
            {subLabel && (
              <label
                style={{
                  marginLeft: "0.3rem",
                  color: "gray.500",
                  fontWeight: "normal",
                  fontSize: "0.875rem",
                }}
              >
                ( {subLabel})
              </label>
            )}
          </FormLabel>
        )}

        {select ? (
          // Select dropdown
          <Select
            value={value || ""}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder || `Select ${label}`}
            disabled={disabled}
            {...fieldStyles}
          >
            {options.map((option, index) => (
              <option
                key={typeof option === "object" ? option.value : option}
                value={typeof option === "object" ? option.value : option}
              >
                {typeof option === "object" ? option.label : option}
              </option>
            ))}
          </Select>
        ) : area ? (
          // Textarea
          <Textarea
            value={value || ""}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            rows={4}
            resize="vertical"
            {...fieldStyles}
          />
        ) : leftElement || rightElement ? (
          // Input with left/right elements
          <InputGroup>
            {leftElement && (
              <InputLeftElement
                pointerEvents={
                  typeof leftElement === "function" ? "auto" : "none"
                }
                children={leftElement}
              />
            )}
            <Input
              type={type}
              value={value || ""}
              onChange={onChange}
              onBlur={onBlur}
              placeholder={placeholder}
              disabled={disabled}
              pl={leftElement ? 10 : undefined}
              pr={rightElement ? 10 : undefined}
              {...fieldStyles}
            />
            {rightElement && (
              <InputRightElement pointerEvents="auto" children={rightElement} />
            )}
          </InputGroup>
        ) : (
          // Regular input
          <Input
            type={type}
            value={value || ""}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            {...fieldStyles}
          />
        )}

        {error && (
          <FormErrorMessage fontSize="sm" mt={1}>
            {error}
          </FormErrorMessage>
        )}
      </FormControl>
    </Box>
  );
};

export default CustomSingleInput;
